<!-- 移动端抽屉 v2：顶部居中标题，左侧 close 图标（可插槽覆盖），右侧插槽，底部插槽 -->
<template>
  <el-drawer
    v-model="detailVisible"
    class="xbb-drawer-v2"
    :class="customClass"
    direction="btt"
    :show-close="false"
    :size="size"
  >
    <template #header>
      <div class="xbb-drawer-v2__header">
        <!-- 左侧：优先使用插槽，否则默认 close 图标 -->
        <div class="xbb-drawer-v2__header-left" @click="handleClose">
          <slot name="header-left">
            <i class="icon-close-line t-iconfont xbb-drawer-v2__close-icon"></i>
          </slot>
        </div>

        <!-- 居中标题 -->
        <div class="xbb-drawer-v2__title">
          <slot name="title">{{ title }}</slot>
        </div>

        <!-- 右侧插槽 -->
        <div class="xbb-drawer-v2__header-right">
          <slot name="header-right"></slot>
        </div>
      </div>
    </template>

    <!-- 主内容插槽 -->
    <div class="xbb-drawer-v2__body">
      <slot></slot>
    </div>

    <!-- 底部插槽（无内容则不渲染占位） -->
    <template v-if="$slots.footer" #footer>
      <div class="xbb-drawer-v2__footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </el-drawer>
</template>

<script setup>
defineOptions({ name: 'DrawerV2' })

const emit = defineEmits(['close'])

const detailVisible = defineModel({ type: Boolean, default: false })

const { title, size, customClass } = defineProps({
  title: { type: String, default: '这是名字' },
  size: { type: String, default: '80%' },
  customClass: { type: String, default: '' }
})

const handleClose = () => {
  detailVisible.value = false
  emit('close')
}
</script>

<style lang="scss">
.xbb-drawer-v2 {
  border-radius: 20px 20px 0 0 !important;

  > .el-drawer__header {
    padding: 0;
    margin-bottom: 0;
  }

  > .el-drawer__body {
    padding: 0;
  }

  > .el-drawer__footer {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
@use '@/style/common.scss' as *;

.xbb-drawer-v2 {
  &__header {
    display: flex;

    justify-content: space-between;
    padding: 13px 16px;
    position: relative;
  }

  &__header-left,
  &__header-right {
    min-width: 40px;
    display: flex;
  }

  &__header-left {
    cursor: pointer;
  }

  &__header-right {
    justify-content: flex-end;
  }

  &__close-icon {
    font-size: 20px;
    color: #969799;
  }

  &__title {
    // 三级文字/加粗
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
    color: #323233;
    flex: 1;
    text-align: center;
  }

  &__body {
    height: 100%;
    padding: 0;
  }

  &__footer {
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    border-top: 1px solid #f2f3f5;
  }
}
</style>
